module.exports = __webpack_public_path__ + "img/ae-5.8629913.png";